<template>
  <section
    v-if="isVisible"
    class="cash-summary"
    aria-label="Остатки по кассе"
  >
    <header class="cash-summary__header">
      <div class="cash-summary__heading">
        <span class="cash-summary__icon">
          <Wallet
            :size="22"
            aria-hidden="true"
          />
        </span>

        <div>
          <h2>Обзор кассы</h2>
          <p>Распределение средств по способам оплаты</p>
        </div>
      </div>
    </header>

    <dl class="cash-summary__list">
      <div
        v-for="(field, index) in getComponentFields"
        :key="`cash-summary-${index}`"
        class="cash-summary__item"
      >
        <dt class="cash-summary__title">
          <span class="cash-summary__metric-icon">
            <component
              :is="field.icon"
              :size="20"
              aria-hidden="true"
            />
          </span>
          <span>{{ field.title }}</span>
        </dt>
        <dd class="cash-summary__value">{{ priceToFormat(data[field.name]) }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {priceToFormat} from '@/helper'
import {Wallet, CreditCard, Banknote, ArrowLeftRight} from 'lucide-vue'

export default {
  name: 'CashSummary',
  components: {
    Wallet,
    CreditCard,
    Banknote,
    ArrowLeftRight
  },
  data () {
    return {
      data: []
    }
  },
  computed: {
    ...mapGetters('settings', ['getFields']),
    getComponentFields () {
      return this.getFields?.['dashboard-info']?.cashSummary || []
    },
    isVisible () {
      return this.getComponentFields.length > 0 && Object.keys(this.data || {}).length > 0
    }
  },
  mounted () {
    this.loadData()

    this.$bus.on('update-cash-summary', this.loadData)
  },
  beforeDestroy () {
    this.$bus.off('update-cash-summary', this.loadData)
  },
  methods: {
    ...mapActions('info', ['loadCashSummary']),
    priceToFormat,
    async loadData () {
      const { data } = await this.loadCashSummary() || {}

      this.data = data
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
